/** @format */

import React, { Component } from 'react';
import { Grid, Button, Icon } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('RequestsStore')
@observer
class OptionSoldButtons extends Component {
  render() {
    const { RequestsStore, partId, optionKey } = this.props;
    const currentOption =
      RequestsStore.currentRequest.reqParts[partId].options[optionKey];
    const currentRequestId = RequestsStore.requestsParams.currentRequestId;
    return (
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button
              onClick={() =>
                RequestsStore.soldOption(
                  false,
                  currentRequestId,
                  partId,
                  optionKey,
                )
              }
              disabled={currentOption.data.sold === false}
              fluid
              color="red"
              size="small"
            >
              <Icon name="cancel" />
              Rimuovi dalla vendita
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              onClick={() =>
                RequestsStore.soldOption(
                  true,
                  currentRequestId,
                  partId,
                  optionKey,
                )
              }
              disabled={currentOption.data.sold === true}
              fluid
              color="green"
              size="small"
            >
              <Icon name="check" />
              Aggiungi alla vendita
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default OptionSoldButtons;
